/*
    Hook to handle adding the classPrepend to class names

    props
        (string, required)  prepend  The string to prepend all classnames with

    returns
        (function)  getClassName  Returns the prepended classname attribute
                                    - arguments:
                                        (string, required)  className                  the classname to prepend
                                        (boolean, optional) includeNoPrependClassName  Defaults to false. When true, the classnames are still prepended, but the original classnames are kept too. 
                                                                                            - Meant for stuff like global base styles
                                    - Works with multiple classnames, shown in example
                                    - Example usage:
                                        const [ getClassName, getClassNameWithGlobal ] = useClassPrepend("unstyled");
                                        return (
                                            <p
                                                {...getClassName("hello hello-world")} // results in <p className="unstyled-hello unstyled-hello-world other">
                                            >
                                                Hello World!
                                            </p>
                                        )
        (function)  getClassNameValue  returns the actual classname value instead of the classname prop like getClassName

*/

const useClassPrepend = prepend => {
  const getClassNameValue = (className, includeNoPrependClassName = false) => {
    // Create a list of classes from the className string and remove any extra spaces
    const classNameList = className.split(" ").filter(value => value !== "");

    // Add the prepend to each class
    const prependedClassNameList = classNameList.map(value => {
      if (value.charAt(0) === "-") {
        value = value.slice(1);
      }
      return `${prepend}-${value}`;
    });
    let prependedClassName = prependedClassNameList.join(" ");
    if (includeNoPrependClassName) {
      prependedClassName += ` ${className.trim()}`;
    }
    return prependedClassName;
  };
  const getClassName = (className, includeNoPrependClassName = false) => {
    return {
      className: getClassNameValue(className, includeNoPrependClassName)
    };
  };

  // this code is a mess
  const getClassNameWithGlobal = (globalClassName, customClassName = "") => {
    const globalAndPrependGlobal = getClassNameValue(globalClassName, true);
    const prependCustom = getClassNameValue(customClassName);
    return {
      className: `${globalAndPrependGlobal} ${prependCustom}`
    };
  };
  return [getClassName, getClassNameWithGlobal, getClassNameValue];
};
export { useClassPrepend };